import React from "react";
import ct from "class-types.macro";

const UnitOfMeasure = ({
  unitOfMeasure,
  showBoldOutletFormatting = false,
}: {
  unitOfMeasure: string;
  showBoldOutletFormatting?: boolean;
}) => (
  <span
    data-testid="each"
    className={`each ${ct("text-xs", "leading-none", "text-gray-800")} ${
      showBoldOutletFormatting ? ct("font-bold") : ""
    }`}
  >
    /{showBoldOutletFormatting ? "EA" : unitOfMeasure}
  </span>
);

export default UnitOfMeasure;
